"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Modal = _interopRequireDefault(require("react-bootstrap/Modal"));

var _Message = _interopRequireDefault(require("../i18n/Message"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ErrorModal = function ErrorModal(props) {
  var show = props.show,
      _props$errorMessage = props.errorMessage,
      errorMessage = _props$errorMessage === void 0 ? 'Sorry for the error' : _props$errorMessage,
      onClose = props.onClose;

  var onHide = function onHide() {
    if (onClose) {
      onClose();
    }
  };

  return /*#__PURE__*/_react.default.createElement(_Modal.default, {
    show: show,
    onHide: onHide
  }, /*#__PURE__*/_react.default.createElement(_Modal.default.Header, {
    closeButton: true
  }, /*#__PURE__*/_react.default.createElement(_Modal.default.Title, null, /*#__PURE__*/_react.default.createElement(_Message.default, {
    messageId: "error"
  }))), /*#__PURE__*/_react.default.createElement(_Modal.default.Body, null, errorMessage));
};

ErrorModal.propTypes = {
  show: _propTypes.default.bool,
  errorMessage: _propTypes.default.string,
  onClose: _propTypes.default.func
};
var _default = ErrorModal;
exports.default = _default;